const { Iugu } = window;
export default Iugu;
